import { Component, EventEmitter, Inject, Input, OnDestroy, Output } from '@angular/core';
import { EVENTS } from '../../../constants/events';

@Component({
  selector: 'expression-editor-icon',
  template: ` <i (click)="iconClick()" class="fa fa-edit expression-editor-icon"></i> `,
})
export class ExpressionEditorIconComponent implements OnDestroy {
  @Input() readonlyValue = false;
  @Input() value = '';
  @Output() valueChange = new EventEmitter();
  @Input() type = '';
  @Input() index: number;
  @Input() id: string;

  openedID: string;
  saveEvent;

  constructor(@Inject('$rootScope') private $rootScope: any) {
    this.saveEvent = $rootScope.$on(EVENTS.EXPRESSION_EDITOR_SAVE, (event, code) => {
      this.valueChange.emit({ code, id: this.openedID });
      this.openedID = '';
    });
  }

  cancelEvents() {
    this.saveEvent();
  }

  iconClick() {
    this.openedID = this.id;
    this.$rootScope.$broadcast(EVENTS.EXPRESSION_EDITOR_SHOW, {
      code: String(this.value),
      index: this.index,
      category: this.type === 'user_variables' ? 'User' : 'System',
      extraVariables: {},
    });
  }

  ngOnDestroy() {
    this.cancelEvents();
  }
}
